import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import '../styles/Pages.css';

function FAQPage() {
    const faqs = [
        { q: 'When do admissions open for the new academic year?', a: 'Admissions typically open in June each year, following the declaration of HSC (12th) results by Maharashtra State Board. Check the Notices section for exact dates.' },
        { q: 'What courses does the college offer?', a: 'The college offers undergraduate programs in Arts (B.A.), Science (B.Sc.), and Computer Science (B.Sc. CS/IT). Certificate courses are also available.' },
        { q: 'Is the college affiliated with a university?', a: 'Yes, Shri Mulikadevi Mahavidyalaya, Nighoj is affiliated with Savitribai Phule Pune University (SPPU).' },
        { q: 'How do I apply for admission?', a: 'You can apply online via the Admissions section on this website or visit the college office in person during working hours.' },
        { q: 'What is the fee structure?', a: 'Fee structures vary by programme. For the latest fee details, contact the college office at (02488) 230438 or email ascnighoj@gmail.com.' },
        { q: 'Are scholarships available?', a: 'Yes. The college facilitates government scholarships (Mahadbt), university scholarships, and merit-based awards. Visit the Scholarships section for more details.' },
        { q: 'What is the NAAC grade of the college?', a: 'Shri Mulikadevi Mahavidyalaya, Nighoj is accredited by NAAC with a "B" Grade.' },
        { q: 'How do I contact the college?', a: 'Phone: (02488) 230438 | Email: ascnighoj@gmail.com / info@shrimulikadevicollege.com | Address: Nighoj, Tal. Parner, Dist. Ahmednagar, Maharashtra.' },
        { q: 'Is there an NSS unit in the college?', a: 'Yes. The college has an active NSS unit that organizes community service activities, camps, and social awareness programs throughout the year.' },
        { q: 'What are the library timings?', a: 'Library is open Monday–Friday: 8:00 AM – 6:00 PM, Saturday: 9:00 AM – 1:00 PM. Closed on Sundays and public holidays.' },
    ];

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › FAQ</p>
                <h1>Frequently Asked Questions</h1>
                <p>Find answers to the most common queries about our college.</p>
            </div>
            <div className="page-content">
                {faqs.map((f, i) => (
                    <details key={i} style={{ marginBottom: '0.8rem', background: '#fff', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)', padding: '1rem 1.2rem', cursor: 'pointer' }}>
                        <summary style={{ fontWeight: 700, color: '#1a3c5e', fontSize: '1rem', listStyle: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            {i + 1}. {f.q} <span style={{ fontSize: '1.2rem', color: '#2d6a4f' }}>＋</span>
                        </summary>
                        <p style={{ color: '#555', marginTop: '0.7rem', lineHeight: 1.7, fontSize: '0.95rem' }}>{f.a}</p>
                    </details>
                ))}
                <div className="info-card" style={{ marginTop: '1.5rem' }}>
                    <h2>Still have a question?</h2>
                    <p>Contact us at <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a> or call <strong>(02488) 230438</strong>. You can also visit our <a href="/contact-us" style={{ color: '#2d6a4f' }}>Contact Us</a> page.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default FAQPage;
